import {ReadonlyDeep} from 'type-fest';
import {WorkerEntity} from '../../../universal/features/api/entity/dashboard/worker/WorkerEntity';

export default (worker: ReadonlyDeep<WorkerEntity>): string =>
  (worker.name || worker.host_info?.hostname) ?? worker.id;
